'use client';

import {
	InHouseStreamingUrlWithSecretResponse,
	useGetInHouseStreamingUrl,
	useGetInHouseStreamingUrlWithSecret
} from '@/hooks/query/use-streaming-data';
import { useEffect } from 'react';
import { useStreamingStore } from '@/store/streaming';
import { VideoDeviceType } from '@/services/streaming.service';
import { StreamingBase } from '../streaming-base';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { useAccountInfo } from '@/hooks/query/account';

export const InHouseStreaming = ({ matchId,  device }: { matchId: number, device : VideoDeviceType }) => {

	const { SiteConfigsData } = useGetSiteConfigs();
	const enableInHouseUrlApiBackend = SiteConfigsData?.EnableInHouseUrlApiBackend || false;
	
	return enableInHouseUrlApiBackend ? InHouseStreamingWithSecret({ matchId,  device }) : InHouseStreamingWithoutSecret({ matchId,  device });
}

export const InHouseStreamingWithoutSecret = ({ matchId,  device }: { matchId: number, device : VideoDeviceType }) => {
	const [
		streamingSrc,
		channelList,
		streamingUrl,
		setStreamingUrl,
		streamingMatchId,
		isRefresh,
		setIsLoading
	] = useStreamingStore(
		state => [
			state.streamingSrc,
			state.channelList,
			state.streamingUrl,
			state.setStreamingUrl,
			state.streamingMatchId,
			state.isRefresh,
			state.setIsLoading
		]
	);

	const streamingData = channelList?.find((item) => item?.value === streamingSrc);
	const sid = `M${streamingData?.sid}.m3u8`;
	const { refetch } = useGetInHouseStreamingUrl(sid);

	useEffect(() => {
		if (matchId !== streamingMatchId || (streamingUrl && !isRefresh)) {
			return;
		}

		refetch().then((res) => {
			const urlData = res.data?.data.Data?.url;
			if (urlData) {
				setStreamingUrl(urlData);
			}
			setIsLoading(false);
		});
	}, [channelList, isRefresh, streamingSrc, streamingMatchId]);

	return <StreamingBase device={device} />;
};

export const InHouseStreamingWithSecret = ({ matchId,  device }: { matchId: number, device : VideoDeviceType }) => {
	const [
		streamingSrc,
		channelList,
		streamingUrl,
		setStreamingUrl,
		streamingMatchId,
		isRefresh,
		setIsLoading
	] = useStreamingStore(
		state => [
			state.streamingSrc,
			state.channelList,
			state.streamingUrl,
			state.setStreamingUrl,
			state.streamingMatchId,
			state.isRefresh,
			state.setIsLoading
		]
	);

	const streamingData = channelList?.find((item) => item?.value === '13');
	const { user } = useAccountInfo();
	const apiBackendUrl = user?.ApiBackendUrl || '';
	const accessToken = user?.AccessToken || '';
	
	const { refetch } = useGetInHouseStreamingUrlWithSecret(`${streamingData?.sid}`, apiBackendUrl, accessToken);

	useEffect(() => {
		if (matchId !== streamingMatchId || (streamingUrl && !isRefresh)) {
			return;
		}

		refetch().then((res) => {
			const isCn = user?.FromCountry?.toLowerCase() === 'cn';
			const streamingUrlResponse = res.data?.data?.Data;
			const specifiedChannelIndex= streamingSrc.indexOf('-') === -1 ? 0 : Number(streamingSrc.substring(streamingSrc.indexOf('-')+1));
			const specifiedChannel: InHouseStreamingUrlWithSecretResponse | undefined = (!streamingUrlResponse || !streamingUrlResponse[specifiedChannelIndex]) ? undefined : streamingUrlResponse[specifiedChannelIndex];
			if (specifiedChannel) {
				const streamingUrl = isCn ? specifiedChannel.CnStreamingUrl : specifiedChannel.OtherAreaStreamingUrl;
				setStreamingUrl(streamingUrl);
			}
			setIsLoading(false);
		});
	}, [channelList, isRefresh, streamingSrc, streamingMatchId]);

	return <StreamingBase device={device} />;
};

